import React, { useState } from 'react';
import { Button } from 'shared-components';
import styles from './product.module.css';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { IFormField } from '@topshots/core-models';
import { FieldListItem } from '../form-builder/field-list-item';
import { EditFieldForm } from '../form-builder/edit-field-form';

interface FormBuilderProps {
  fields: IFormField[];
  onChange: (fields: IFormField[]) => void;
  disabled?: boolean;
}

export const FormBuilder: React.FC<FormBuilderProps> = ({
  fields,
  onChange,
  disabled,
}) => {
  const dispatch = useAppDispatch();

  const [isAddingField] = useState(false);
  const [editingFieldIndex, setEditingFieldIndex] = useState<number | null>(
    null
  );

  const removeField = (id: string) => {
    onChange(fields.filter((field) => field.id !== id));
  };

  const renderFieldEditor = (field: IFormField, index: number) => (
    <EditFieldForm
      index={index}
      onDone={() => {
        onChange(fields.map((f, i) => (i === index ? field : f)));
        setEditingFieldIndex(null);
      }}
      field={field}
    />
  );

  if (editingFieldIndex != null) {
    const field = fields.find((f, i) => i === editingFieldIndex);
    return field ? renderFieldEditor(field, fields.indexOf(field)) : null;
  }

  if (isAddingField) {
    return <h1>NEw Field form</h1>;
  }

  return (
    <div className={styles.formBuilder}>
      {!disabled && (
        <Button
          onClick={() => {
            dispatch(
              open({
                title: 'New Field',
                contentKey: 'add-field',
                callback: (newField: IFormField) => {
                  if (newField) {
                    onChange([...fields, newField]);
                  }
                },
              })
            );
          }}
        >
          Add New Field
        </Button>
      )}
      <div className={styles.fieldsList}>
        {fields.map((f, i) => (
          <FieldListItem
            key={f.id}
            isFirst={i === 0}
            isLast={i === fields.length - 1}
            field={f}
            onUp={() => {
              if (i > 0) {
                const newFields = [...fields];
                [newFields[i], newFields[i - 1]] = [
                  newFields[i - 1],
                  newFields[i],
                ];
                onChange(newFields);
              }
            }}
            onDown={() => {
              if (i < fields.length - 1) {
                const newFields = [...fields];
                [newFields[i], newFields[i + 1]] = [
                  newFields[i + 1],
                  newFields[i],
                ];
                onChange(newFields);
              }
            }}
            onEdit={() => {
              setEditingFieldIndex(i);
            }}
            onRemove={removeField}
          />
        ))}
      </div>
    </div>
  );
};
